/**
 * Created by mukund on 7/24/17.
 */

angular.module('mediacloudApp')
    .directive('publisher', ['$rootScope', '$state', '$timeout', '$filter', '$http', 'CollectionService', 'BaseFileService', 'BatchService', 'UploadErrors', 'SearchService', function($rootScope, $state, $timeout, $filter, $http, CollectionService, BaseFileService, BatchService, UploadErrors, SearchService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/upload/directives/publisher/publisher.html',
            scope: {
                file: '=',
                batches: '=',
                account: '='
            },
            link: function (scope, element, attrs) {

                if (scope.account) {

                    var origin;

                    // For pagination
                    scope.collectionsPerPage = 10;
                    scope.currentPage = 1;

                    scope.closeFolderSelectionModal = function () {
                        scope.selectedFolder = null;
                        $('#publishWindow').modal('hide');
                    };

                    // TODO refactor if possible
                    var getChildFolders = function (pcid, $event) {
                        // Reset pagination every time we load a new level of children
                        scope.currentPage = 1;
                        if (pcid === '101') {
                            CollectionService.GetAllCollections.get({type: 'COURSE', limit: scope.collectionsPerPage, offset: (scope.currentPage - 1) * scope.collectionsPerPage, paginated: true}, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    showChildFolders(result.collections, $event);
                                    scope.expandedFolder.totalCollections = result.totalCollections;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        } else if (pcid === '100') {
                            CollectionService.GetAllCollections.get({type: 'CHANNEL', limit: scope.collectionsPerPage, offset: (scope.currentPage - 1) * scope.collectionsPerPage, paginated: true}, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    showChildFolders(result.collections, $event);
                                    scope.expandedFolder.totalCollections = result.totalCollections;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        } else if (pcid === '104') {
                            CollectionService.GetAllCollections.get({type: 'PROTECTED', limit: scope.collectionsPerPage, offset: (scope.currentPage - 1) * scope.collectionsPerPage, paginated: true}, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    showChildFolders(result.collections, $event);
                                    scope.expandedFolder.totalCollections = result.totalCollections;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        } else {
                            CollectionService.GetCollectionContent.get({
                                cid: pcid,
                                fol: true,
                                offset: (scope.currentPage - 1) * scope.collectionsPerPage,
                                limit: scope.collectionsPerPage
                            }, function (result) {
                                if (result.contents && result.contents.length > 0) {
                                    showChildFolders(result.contents, $event);
                                    scope.expandedFolder.totalCollections = result.totalContents;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        }
                    };

                    scope.loadMoreFolders = function(){
                        scope.showSpinner = true;
                        scope.currentPage++;

                        if(scope.searchEnabled){

                            var sitewide = true,
                                collectionId = '';

                            if ($state.params.collectionId && $state.params.collectionId !== "000") {
                                sitewide = false;
                                collectionId = $state.params.collectionId;
                            }

                            SearchService.SearchCollections.get({
                                query: scope.searchField.query,
                                sitewide: sitewide,
                                cid: collectionId,
                                limit: scope.collectionsPerPage,
                                offset: (scope.currentPage - 1) * scope.collectionsPerPage
                            }, function (result) {
                                scope.showSpinner = false;
                                if (result.collections && result.collections.length > 0) {
                                    scope.childFolders = scope.childFolders.concat(result.collections);
                                }
                                // We re-purpose the expandedFolder variable for the search results screen
                                scope.expandedFolder = {title: "Search Results"};
                                scope.expandedFolder.totalCollections = result.totalCollections ? result.totalCollections : 0;
                            });

                        } else {
                            var parent = scope.expandedFolder;
                            if (parent.path === '/') {
                                CollectionService.GetAllCollections.get({
                                    type: parent.type.toUpperCase(),
                                    limit: scope.collectionsPerPage,
                                    offset: (scope.currentPage - 1) * scope.collectionsPerPage,
                                    paginated: true
                                }, function (result) {
                                    scope.showSpinner = false;
                                    if (result.collections && result.collections.length > 0) {
                                        scope.childFolders = scope.childFolders.concat(result.collections);
                                    }
                                    parent.totalCollections = result.totalCollections ? result.totalCollections : 0;
                                });
                            } else {
                                var pcid = parent.cid ? parent.cid : parent.xid;
                                CollectionService.GetCollectionContent.get({
                                    cid: pcid,
                                    fol: true,
                                    offset: (scope.currentPage - 1) * scope.collectionsPerPage,
                                    limit: scope.collectionsPerPage
                                }, function (result) {
                                    scope.showSpinner = false;
                                    if (result.contents && result.contents.length > 0) {
                                        scope.childFolders = scope.childFolders.concat(result.contents);
                                    }
                                    parent.totalCollections = result.totalContents ? result.totalContents : 0;
                                });
                            }
                        }
                    };

                    scope.setExpandedFolder = function(parent, $event, addChildColumn){
                        scope.searchEnabled = false;
                        if(parent.path === '/'){
                            setOrigin(parent);
                        } else {
                            selectFolder(parent, $event);
                        }
                        if(addChildColumn) {
                            scope.folderColumns.push(1);
                        }
                        scope.expandedFolder = parent;
                        var pcid = parent.cid ? parent.cid : parent.xid;
                        getChildFolders(pcid, $event);
                        $timeout(function () {
                            var currentleft = (scope.folderColumns.length - 1) * 100 * -1;
                            var newleft = (currentleft - 100) + '%';
                            $('.folder-column').css( "left", newleft );
                        }, 0, false);
                    };

                    var setOrigin = function(parent){
                        origin = parent;
                    };

                    // TODO refactor if possible
                    scope.getParentFolders = function($event){

                        var currentleft = scope.folderColumns.length * 100 * -1;
                        var newleft = (currentleft + 100) + '%';
                        $('.folder-column').css( "left", newleft );

                        scope.folderColumns.pop();

                        // The home screen will be shown. There is nothing else to do here.
                        if(scope.expandedFolder.path === '/'){
                            scope.showBackButton = false;
                            return;
                        }

                        var pcid = scope.expandedFolder.path.substring(scope.expandedFolder.path.lastIndexOf("/") + 1);

                        if(pcid === '101' || pcid === '104' || pcid === '100'){
                            if($state.params.collectionId && $state.params.collectionId !== "000") {
                                scope.showBackButton = false;
                            } else if((origin && origin.type.toLowerCase() === 'course') || (!origin && pcid === '101')){
                                scope.expandedFolder = scope.parentFolders[0];
                                pcid = scope.expandedFolder.cid;
                            } else if((origin && origin.type.toLowerCase() === 'protected') || (!origin && pcid === '104')){
                                scope.expandedFolder = scope.parentFolders[1];
                                pcid = scope.expandedFolder.cid;
                            } else if((origin && origin.type.toLowerCase() === 'channel') || (!origin && pcid === '100')){
                                scope.expandedFolder = scope.parentFolders[2];
                                pcid = scope.expandedFolder.cid;
                            }
                            getChildFolders(pcid, $event);
                            scope.selectedFolder = false;
                        } else {
                            var parentType = 'COURSE';

                            if(scope.expandedFolder.path.startsWith("/104")) {
                                parentType = 'PROTECTED';
                            } else if(scope.expandedFolder.path.startsWith("/100")) {
                                parentType = 'CHANNEL';
                            }

                            CollectionService.GetCollection.get({
                                cid: pcid,
                                type: parentType
                            }, function (result) {
                                scope.showBackButton = true;
                                if(scope.folderColumns.length){
                                    scope.setExpandedFolder(result, $event, false);
                                } else {
                                    scope.setExpandedFolder(result, $event, true);
                                }
                            });
                        }
                    };

                    var showChildFolders = function (children, $event) {
                        var pcid = scope.expandedFolder.path.substring(scope.expandedFolder.path.lastIndexOf("/") + 1);
                        if($state.params.collectionId && $state.params.collectionId !== "000") {
                            scope.showBackButton = ['100', '101', '104'].indexOf(pcid) === -1;
                        } else {
                            scope.showBackButton = true;
                        }
                        scope.childFolders = [].concat(children);
                    };

                    var selectFolder = function (folder, event) {
                        scope.selectedFolder = folder;
                        if(event) {
                            event.stopPropagation()
                        }
                    };

                    scope.getFoldersForPublishing = function () {

                        // Array used by ng-repeat used for folder transition effect
                        scope.folderColumns = [];

                        $('.folder-column').css( "left", "0%" );

                        scope.searchEnabled = false;
                        scope.childFolders = [];
                        scope.folderPath = [];
                        scope.showBackButton = true;
                        scope.expandedFolder = null;
                        scope.searchField = {query: ''};
                        scope.selectedFolder = null;

                        // 000 - collectionId is equivalent to no collectionId
                        if ($state.params.collectionId && $state.params.collectionId !== "000") {
                            CollectionService.GetCollection.get({
                                cid: $state.params.collectionId,
                                type: 'COURSE'
                            }, function (result) {
                                scope.setExpandedFolder(result, undefined, true);
                            });
                        } else {
                            scope.parentFolders = [
                                {
                                    title: 'Courses',
                                    cid: '101',
                                    type: 'course',
                                    acl: 'RW',
                                    path: '/'
                                },
                                {
                                    title: 'Collections',
                                    cid: '104',
                                    type: 'protected',
                                    acl: 'RW',
                                    path: '/'
                                },
                                {
                                    title: 'Channels',
                                    cid: '100',
                                    type: 'channel',
                                    acl: 'RW',
                                    path: '/'
                                }
                            ];
                        }
                    };

                    scope.publishFile = function () {
                        var fileToBePublished = scope.file;
                        fileToBePublished.publishLocation = scope.selectedFolder;
                        var collectionId = fileToBePublished.publishLocation.cid ? fileToBePublished.publishLocation.cid : fileToBePublished.publishLocation.xid,
                            path = fileToBePublished.publishLocation.path;
                        // $rootScope.rootLevelCid = collectionId;
                        fileToBePublished.publishLocation.cid = collectionId;
                        if(path) {
                            if (path === '/101' || path.indexOf('/101/') > -1) {
                                fileToBePublished.publishLocation.type = 'course';
                            } else if (path === '/100' || path.indexOf('/100/') > -1) {
                                fileToBePublished.publishLocation.type = 'channel';
                            } else {
                                fileToBePublished.publishLocation.type = 'protected';
                            }
                        }
                        if (fileToBePublished.isBatch) {
                            if(fileToBePublished.inProgress){
                                var batchResource = new BatchService.Destination({
                                    batchId: fileToBePublished.batchId,
                                    collectionId: collectionId
                                });
                                batchResource.$save(function () {
                                    angular.forEach(fileToBePublished.files, function (file) {
                                        if (!file.destinationSelected) {
                                            file.destinationSelected = true;
                                            file.published = false;
                                            file.publishLocation = fileToBePublished.publishLocation;
                                        }
                                    });
                                    fileToBePublished.destinationSelected = true;
                                    fileToBePublished.published = false;
                                }, function () {
                                    fileToBePublished.errors.push({
                                        id: 'pue' + Date.now(),
                                        msg: UploadErrors.PUBLISH_BATCH
                                    });
                                });
                            }else {
                                var batchResource = new BatchService.Publish({
                                    batchId: fileToBePublished.batchId,
                                    collectionId: collectionId,
                                    subtitles: fileToBePublished.subtitles
                                });
                                batchResource.$save(function () {
                                    angular.forEach(fileToBePublished.files, function (file) {
                                        if (!file.publishClicked) {
                                            file.publishClicked = true;
                                            file.published = false;
                                            file.publishLocation = fileToBePublished.publishLocation;
                                        }
                                    });
                                    fileToBePublished.publishClicked = true;
                                    fileToBePublished.published = false;
                                }, function () {
                                    fileToBePublished.errors.push({
                                        id: 'pue' + Date.now(),
                                        msg: UploadErrors.PUBLISH_BATCH
                                    });
                                });
                            }
                        } else {
                            if(fileToBePublished.inProgress && scope.defaultUploader){
                                var baseFileResource = new BaseFileService.Destination({
                                    id: scope.file.mediacloudFileId,
                                    fileId: fileToBePublished.fileId,
                                    collectionId: collectionId,
                                    destinationCollectionId: collectionId,
                                    meetingUuid: ""
                                });
                                baseFileResource.$save(function () {
                                    fileToBePublished.destinationSelected = true;
                                    fileToBePublished.published = false;
                                    var filesWithDestination = 0;
                                    var batch = $filter('filter')(scope.batches, {batchId: fileToBePublished.batchId}, true)[0];
                                    if (batch) {
                                        angular.forEach(batch.files, function (file) {
                                            if (file.destinationSelected) {
                                                filesWithDestination++;
                                            }
                                        });
                                        if (filesWithDestination === batch.files.length) {
                                            batch.destinationSelected = true;
                                            batch.published = false;
                                        }
                                    }
                                }, function () {
                                    fileToBePublished.errors.push({
                                        id: 'pue' + Date.now(),
                                        msg: UploadErrors.PUBLISH_FILE.formatMessage({name: fileToBePublished.name})
                                    });
                                });
                            }else{
                                fileToBePublished.publishMessage = 'Publishing ...';
                                var baseFileResource = new BaseFileService.Publish({
                                    fileId: fileToBePublished.fileId,
                                    collectionId: collectionId,
                                    subtitles: fileToBePublished.subtitles
                                });
                                baseFileResource.$save(function () {
                                    fileToBePublished.publishClicked = true;
                                    fileToBePublished.published = false;
                                    var publishedFiles = 0;
                                    var batch = $filter('filter')(scope.batches, {batchId: fileToBePublished.batchId}, true)[0];
                                    if (batch) {
                                        angular.forEach(batch.files, function (file) {
                                            if (file.publishClicked) {
                                                publishedFiles++;
                                            }
                                        });
                                        if (publishedFiles === batch.files.length) {
                                            batch.publishClicked = true;
                                            batch.published = false;
                                        }
                                    }
                                }, function () {
                                    fileToBePublished.errors.push({
                                        id: 'pue' + Date.now(),
                                        msg: UploadErrors.PUBLISH_FILE.formatMessage({name: fileToBePublished.name})
                                    });
                                });
                            }
                        }
                        scope.closeFolderSelectionModal();
                    };

                    scope.checkForSpace = function (item, isChild, event) {
                        if (event.keyCode === 32) {
                            // Ensures My Courses/ Channels doesn't get selected
                            if (!isChild && ['100', '101', '104'].indexOf(item.cid) > -1) {
                                return;
                            }
                            selectFolder(item, event);
                        } else if (event.keyCode === 13) {
                            scope.setExpandedFolder(item, event, true);
                        }
                    };

                    scope.checkForEnter = function (event) {
                        if (event.keyCode === 13) {
                            scope.searchForFolder();
                        }
                    };


                    scope.searchForFolder = function () {
                        if(scope.searchField.query) {
                            scope.searchTerm = scope.searchField.query;
                            scope.searchEnabled = true;
                            $('.folder-column').css("left", "0%");
                            scope.folderColumns = [1];
                            scope.currentPage = 1;

                            var sitewide = true,
                                collectionId = '';

                            if ($state.params.collectionId && $state.params.collectionId !== "000") {
                                sitewide = false;
                                collectionId = $state.params.collectionId;
                            }

                            SearchService.SearchCollections.get({
                                query: scope.searchField.query,
                                sitewide: sitewide,
                                cid: collectionId,
                                limit: scope.collectionsPerPage,
                                offset: (scope.currentPage - 1) * scope.collectionsPerPage
                            }, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    scope.childFolders = [].concat(result.collections);
                                } else {
                                    scope.childFolders = [];
                                }
                                // We re-purpose the expandedFolder variable for the search results screen
                                scope.expandedFolder = {title: "Search Results"};
                                scope.expandedFolder.totalCollections = result.totalCollections ? result.totalCollections : 0;
                            });

                            $timeout(function () {
                                var currentleft = (scope.folderColumns.length - 1) * 100 * -1;
                                var newleft = (currentleft - 100) + '%';
                                $('.folder-column').css("left", newleft);
                            }, 0, false);
                        } else {
                            scope.cancelSearch();
                        }
                    };

                    scope.cancelSearch = function() {
                        scope.getFoldersForPublishing();
                    };

                    scope.$watch('file.publishTime', function(){
                        if(scope.file){
                            $http({
                                method: 'GET',
                                url: 'api/properties?name=FEATURE_FLAG_DEFAULT_UPLOADER'
                            }).then(function successCallback(response) {
                                if (response.data.value != null) {
                                    scope.defaultUploader = response.data.value;
                                }
                            });
                            scope.getFoldersForPublishing();
                        }
                    });
                }
            }
        }
    }]);
